import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";

export default function MaintenancePlaceholder() {
  const { t } = useTranslation();

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <Card style={{ maxWidth: 640, width: "100%" }}>
        <Typography.Title level={3}>{t("maintenancePlaceholder.title")}</Typography.Title>
        <Typography.Paragraph>{t("maintenancePlaceholder.description")}</Typography.Paragraph>
      </Card>
    </div>
  );
}
